import { IExternalNavigationItem, INavigationItem } from "./interfaces";

export const isExternalNavigationItem = (item: INavigationItem): item is IExternalNavigationItem =>
  (item as IExternalNavigationItem).externalUrl !== undefined;
